module.exports = __webpack_public_path__ + "img/secured.657c9e2.png";